import { useParams } from "react-router-dom";
import ConsentForm from "./ConsentForm";
import { useQuery } from "../../../../../../utils/hooks";

const StudyConsentForm = () => {
  const { id: studyId, participantId, consentId } = useParams();
  const formId = useQuery().get("versionId");
  return (
    <ConsentForm
      studyId={studyId || ""}
      participantId={participantId || ""}
      consentId={consentId || ""}
      formId={formId || ""}
      type="study"
    />
  );
};

export default StudyConsentForm;
